module.exports = __webpack_public_path__ + "img/bg_security.16fb03f9.svg";